import axios from 'axios';
import cookies from 'js-cookie';
import AlertAndConfirmation from './AlertAndConfirmation';

const getUrl = route => `${API_ENDPOINT}/${route}`;

const getRequestHeaders = withAuth => {
  return {
    'Content-Type': 'application/json; charset=utf-8',
    'auth-token': withAuth ? cookies.get('auth-token') : undefined,
  };
};

export const fetchAPI = ({
  route,
  method = 'GET',
  data = {},
  withAuth = true,
  params = null,
  responseType = 'json',
}) => {
  return new Promise((resolve, reject) => {
    axios
      .request({
        url: getUrl(route),
        method,
        headers: getRequestHeaders(withAuth),
        data,
        params,
        responseType,
      })
      .then(result => {
        resolve(result.data ? result.data : result);
      })
      .catch(err => {
        console.error('error in connecting to network', err);
        console.log('err.response', err.response);
        if (
          err.response?.data?.status === 'ERROR' ||
          err.response?.data?.status === 'FAIL'
        ) {
          AlertAndConfirmation({
            title: `خطا ${err.response.status}`,
            text: err.response?.data?.message,
            type: 'error',
            timer: 6000,
          });
        }
        if (err.response && err.response.status === 401) {
          console.error(route, '401');
          window.location.pathname = '/login';
          reject(err);
        } else if (err.response && err.response.status === 400) {
          reject(err.response.data);
        } else {
          console.log(err.response);
          reject(err);
        }
      });
  });
};

export const getFileFromAPI = ({
  route,
  contentType,
  method = 'GET',
  withAuth = true,
  responseType = 'blob',
}) => {
  return new Promise((resolve, reject) => {
    axios
      .request({
        url: getUrl(route),
        method,
        responseType,
        headers: {
          'Content-Type': contentType,
          'auth-token': withAuth ? cookies.get('auth-token') : undefined,
        },
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        console.error('error in connecting to network', err);

        if (err.response && err.response.status === 401) {
          console.error(route, '401');
          window.location.pathname = '/login';
          reject(err);
        } else if (err.response && err.response.status === 400) {
          reject(err.response.data);
        } else {
          reject(err);
        }
      });
  });
};
